import { render, staticRenderFns } from "./ApproveEditPage.vue?vue&type=template&id=5a261d42&scoped=true&"
import script from "./ApproveEditPage.vue?vue&type=script&lang=js&"
export * from "./ApproveEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ApproveEditPage.vue?vue&type=style&index=0&id=5a261d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a261d42",
  null
  
)

export default component.exports